import React, { useState } from 'react'
import './Messagerie.css' ;
import messageicen from '../../../asserts/images/message.png'
import deleteicon from '../../../asserts/images/delete.png'
import {MESSAGES} from './data' ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch , faSortDown , faSortUp} from '@fortawesome/free-solid-svg-icons';
function Messagerie() {
  const [showiconsearch , setShowiconsearch]=useState(true) ;
  const [sourcedown , setSourcedown]=useState(true) ;
  const [sujetdown , setSujetdown]=useState(true) ;
  const [datedown , setDatedown]=useState(true) ;
  const [actiondown , setActiondown]=useState(true) ;



  const handleiconsearch =()=>{
    setShowiconsearch(!showiconsearch);
  }

  const handleDown = (variableName) => {
    switch (variableName) {
      case "source":
        setSourcedown(!sourcedown);
        break;
      case "sujet":
        setSujetdown(!sujetdown);
        break;
      case "date":
        setDatedown(!datedown);
        break;
      case "action":
        setActiondown(!actiondown);
        break;
      default:
        break;
    }
  }
  

  return (
    <>  
     <div className='messageriebox'>
     <p className='title'>Boite de réception <span>(10/200)</span></p>
        <hr/>     
        <img src={messageicen} alt='mesaageicon' className='mesaageicon'/>

        
         <div className='messagescontainer'>
          <div className='headmessagescontainer'>
            <div className='containerlist'>
              <p>Affichage</p>
              <select className='listederoulante'>
                <option value="10">10 par page</option>
                <option value="20">20 par page</option>
                <option value="30">30 par page</option>
              </select>
            </div>
        
            <div className=' containersearch'>
              <FontAwesomeIcon icon={faSearch}  className='iconsearch' />
              <input type='search' placeholder='recherche' onClick={handleiconsearch}/>
            </div>
          
        </div>
        <div className='sousheadmessagescontainer'>
          <div className='divsourcebar'>
            <p>Source</p> 
            <div className='containerupdown'>
                <FontAwesomeIcon icon={faSortUp} className={`${sourcedown ? 'upicon' : 'iconsearchnone'}`} onClick={() => handleDown("source")}/>
                <FontAwesomeIcon icon={faSortDown} className={`${sourcedown ? 'iconsearchnone ' : 'downicon'}`} onClick={() => handleDown("source")} />
            </div>
           
          </div>
          <div className='divsujetbar'>
            <p>Sujet</p> 
            <div className='containerupdown'>
                <FontAwesomeIcon icon={faSortUp} className={`${sujetdown ? 'upicon' : 'iconsearchnone'}`} onClick={() => handleDown("sujet")} />
                <FontAwesomeIcon icon={faSortDown} className={`${sujetdown ? 'iconsearchnone ' : 'downicon'}`} onClick={() => handleDown("sujet")} />
            </div>
          </div>
          <div className='divdatebar'>
            <p>Date</p> 
            <div className='containerupdown'>
                <FontAwesomeIcon icon={faSortUp} className={`${datedown ? 'upicon' : 'iconsearchnone'}`} onClick={() => handleDown("date")}/>
                <FontAwesomeIcon icon={faSortDown} className={`${datedown ? 'iconsearchnone ' : 'downicon'}`} o onClick={() => handleDown("date")} />
            </div>
          </div>
          <div className='divactionbar'>
            <p>Action</p> 
            <div className='containerupdown'>
                <FontAwesomeIcon icon={faSortUp} className={`${actiondown ? 'upicon' : 'iconsearchnone'}`}  onClick={() => handleDown("action")} />
                <FontAwesomeIcon icon={faSortDown} className={`${actiondown ? 'iconsearchnone ' : 'downicon'}`}  onClick={() => handleDown("action")} />
            </div>
          </div>
        </div>
        <div className='containermessages'>

        {MESSAGES.map((item) => (
          <div className='message sousheadmessagescontainer'> 

             <div className='divsourcebarmsg'>
            <p>{item.source}</p>
           </div>
             <div className='divsujetbarmsg'>
             <p>{item.sujet}</p>

             </div>
             <div className='divdatebarmsg'>
             <p>{item.date}</p>

             </div>
             <div className='divactionbarmsg'>
               <img src={deleteicon} />
             </div>
             </div>

          

        ))}

         
        
        </div>
      </div>
    </div>
      


    </>
  )
}

export default Messagerie